var app = angular.module('leonardo');

var PropertyBaseForm = function (
  $scope,
  $q,
  $filter,
  LevelService,
  $rootScope,
  ContactTypeRestService,
  ContactRestService,
  PropertyGroupService,
  PermissionService,
  AccountUserService,
  AccountUserRoleService,
  ChargeCodeService,
  PmsPlatformsService,
  CurrencyRestService,
  AuthDataService,
  AccountService
) {
  $scope.permissionService = PermissionService;
  $scope.accountUserRoleService = AccountUserRoleService;
  $scope.contactRestService = ContactRestService;
  $scope.pmsPlatformsService = PmsPlatformsService;
  $scope.currencyRestService = CurrencyRestService;
  $scope.AuthDataService = AuthDataService;

  $scope.isNull = isNull;
  $scope.isEmpty = isEmpty;

  $scope.accountUser = AccountUserService.getAccountUser($scope.property.account);
  $scope.currencies = CurrencyRestService.getAll({account:$scope.property.account});
  $scope.accountCountry = AuthDataService.authData && AuthDataService.authData.account ? angular.copy(AuthDataService.authData.account.country) : null;

  if (PermissionService.permissionAvailable('permission_view_contact', $scope.accountUser)) {
    if (ContactTypeRestService.getCollection().length > 0) {
      $scope.types = angular.copy(ContactTypeRestService.getCollection());
    } else {
      $scope.types = ContactTypeRestService.getAll({ essential: true });
    }
  }

  $scope.chargeCodeService = function () {
    if (
      PermissionService.permissionAvailableAccount('permission_view_charges') &&
      PermissionService.permissionAvailable('permission_define_property_charge_codes', $scope.accountUser)
    ) {
      let pms_platform = $scope.property.pms_platform ? $scope.property.pms_platform.id : 1;
      ChargeCodeService.getAll({ account: $scope.property.account, summary: true, pms_platform: pms_platform }).then(function (data) {
        $scope.chargeCodes = data;
        $scope.chargeCodes.forEach((chargeCode) => {
          if (chargeCode.property_default_amounts[$scope.property.id]) {
            chargeCode.amount = chargeCode.property_default_amounts[$scope.property.id];
          } else {
            chargeCode.amount = chargeCode.default_amount;
          }
        });
      });
    }
  };

  $scope.getNameById = function (array, id) {
    var name = null;
    angular.forEach(array, function (value) {
      if (id == value.id) {
        name = value.name;
      }
    });
    return name;
  };

  $scope.onStreetChange = function () {
    $rootScope.$broadcast('address-street:updated', $scope.data.fields.street_address);
  };

  $scope.resetRoles = function () {
    if (!$scope.data.notify_on_new_task_creation) {
      $scope.data.roles_notify = [];
    }
  };

  $scope.removeContact = function (index) {
    var contacts = angular.copy($scope.data.contacts);
    angular.forEach($scope.data.contacts, function (value, key) {
      if (key > index) {
        contacts[key - 1] = contacts[key];
      }
    });
    contacts.splice(contacts.length - 1, 1);
    $scope.data.contacts = contacts;
  };

  $scope.getTypeField = function (key) {
    var type = null;
    angular.forEach($scope.fieldSubgroups, function (group) {
      angular.forEach(group.fields, function (field) {
        if (key === field.key) {
          type = field.type;
        }
      });
    });
    return type;
  };

  $scope.overridableInitParams = function () {
    // This is intentional do_something blank function
  };

  $scope.initParams = function () {
    $scope.data = {
      name: $scope.property.name,
      account: $scope.property.account,
      portfolio: $scope.property.portfolio,
      pms_platform: $scope.property.pms_platform ? $scope.property.pms_platform.id || $scope.property.pms_platform : undefined,
      pms_external_id: $scope.property.pms_external_id,
      novice: $scope.property.novice,
      fields: $scope.property.fields,
      billing_email: $scope.property.billing_email,
      notify_on_new_task_creation: $scope.property.notify_on_new_task_creation,
      roles_notify: $scope.property.roles_notify ? $scope.property.roles_notify : [],
      groups: $scope.property.groups ? $scope.property.groups : [],
      permission_upload_charge_to_pms: $scope.property.permission_upload_charge_to_pms,
      currency_code: $scope.property.currency_code || getCurrency(),
      sync_with_crm: $scope.property.sync_with_crm,
      cancellation_date: $scope.property.cancellation_date,
      is_sertis_master: $scope.property.is_sertis_master
    };
    var levels = { country: $scope.property.country ? $scope.property.country.id || $scope.property.country : null };
    $scope.data.contacts = [];
    angular.forEach($scope.property.contacts, function (contact) {
      $scope.data.contacts.push({ contact: contact.id, contact_type: contact.contact_type.id });
    });
    $scope.data.groups = [];
    angular.forEach($scope.property.groups, function (group) {
      $scope.data.groups.push(group.id ? group.id : group);
    });

    angular.forEach($scope.property.levels, function (value) {
      if (value && !isNull(value.level_type)) {
        switch (value.level_type) {
          case LevelService.TYPE_STATE:
            levels.state = value.id;
            break;
          case LevelService.TYPE_COUNTY:
            levels.county = value.id;
            break;
          case LevelService.TYPE_CITY:
            levels.city = value.id;
            break;
          case LevelService.TYPE_ZIPCODE:
            levels.zipcode = value.id;
            break;
        }
      }
    });

    if (!levels.zipcode && $scope.property.fields.zipcode) {
      levels.zipcode = $scope.property.fields.zipcode;
      delete $scope.property.fields.zipcode;
    }

    $scope.data.fields.property_complete_address = {
      address: $scope.property.fields.property_complete_address || '',
      long: $scope.property.longitude || null,
      lat: $scope.property.latitude || null,
      street: $scope.property.fields.street_address || '',
      state: levels.state || null,
      county: levels.county || null,
      city: levels.city || null,
      zipcode: levels.zipcode || null
    };

    $scope.data.levels_data = levels;

    angular.forEach($scope.property.fields, function (field, key) {
      if ($scope.getTypeField(key) === 'bool') {
        $scope.property.fields[key] = field ? true : false;
      } else if ($scope.getTypeField(key) === 'integer') {
        if (!isNull(field)) {
          $scope.property.fields[key] = !isNaN(field) ? Number(field) : null;
        } else {
          $scope.property.fields[key] = null;
        }
      }
    });

    $scope.overridableInitParams();
  };

  $scope.getData = function () {
    var data = angular.copy($scope.data);
    if (!isNull(data.fields.property_complete_address)) {
      data.longitude = data.fields.property_complete_address.long;
      data.latitude = data.fields.property_complete_address.lat;
      data.fields.property_complete_address = data.fields.property_complete_address.address;
    }
    if (angular.isArray($scope.data.groups)) {
      data.groups = $scope.data.groups;
    }
    else {
      data.groups = !isNull($scope.data.groups) ? $scope.data.groups.split(',') : []
    }
    if (angular.isArray($scope.data.roles_notify)) {
      data.roles_notify = $scope.data.roles_notify;
    }
    else {
      data.roles_notify = !isNull($scope.data.roles_notify) ? $scope.data.roles_notify.split(',') : []
    }
    data.contacts = [];
    angular.forEach($scope.data.contacts, function (value) {
      if (value.contact) {
        data.contacts.push(value.contact);
      }
    });
    data.country = data.levels_data.country;
    data.levels = [];
    if (data.levels_data.state) {
      data.levels.push(data.levels_data.state);
    }
    if (data.levels_data.county) {
      data.levels.push(data.levels_data.county);
    }
    if (data.levels_data.city) {
      data.levels.push(data.levels_data.city);
    }
    if (data.levels_data.zipcode) {
      data.levels.push(data.levels_data.zipcode);
    }
    if ($scope.alterData) {
      $scope.alterData(data);
    }
    return data;
  };

  function getCurrency() {
    const currencyCode = ($scope.accountCountry && $scope.accountCountry.code || '').toLowerCase();
    const currencyOption = AccountService.CURRENCY_CODE_OPTIONS.find(value => value.code === currencyCode);
  
    if (currencyOption) {
      return currencyOption.name;
    } else {
      return 'USD'; // Default currency
    }
  }

};

app.controller('PropertyBaseForm', [
  '$scope',
  '$q',
  '$filter',
  'LevelService',
  '$rootScope',
  'ContactTypeRestService',
  'ContactRestService',
  'PropertyGroupService',
  'PermissionService',
  'AccountUserService',
  'AccountUserRoleService',
  'ChargeCodeService',
  'PmsPlatformsService',
  'CurrencyRestService',
  'AuthDataService',
  'AccountService',
  PropertyBaseForm
]);
